import lodash from 'lodash';
import { action, observable } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';
export class PriceQuotationSplitController extends BasesController<any> {
  constructor(public Store) {
    super();
    this.reset({
      dataKey: 'quotationCode',
      infinite: true,
      details: EnumAPI.business_priceQuotationSheetSplit,
      detailsParams: {
        valueGetter: this.valueGetter,
      },
    });
  }
  cacheData = [];
  valueGetter = (response) => {
    const dataSource = Promise.all(
      lodash.map(response, async (item) => {
        const productIds = lodash.map(item.productList, (productItem) => {
          //选择店铺
          productItem.selectShop = {};
          return productItem.productId;
        });
        const selectAddress =
          this.Store.BusinessAddressController.selectAddress;
        const curAddress = selectAddress[item.distributorCode];
        const res: any = await this.getAddressList(item, productIds);
        let firstInfo: any = {};

        if (lodash.size(res.addressList)) {
          if (curAddress) {
            const data = lodash.find(res.addressList, { id: curAddress.id });
            if (data) {
              firstInfo = curAddress;
            } else {
              firstInfo = lodash.get(res.addressList, '[0]');
            }
          } else {
            firstInfo = lodash.get(res.addressList, '[0]');
            this.Store.BusinessAddressController.setDistributorCode(
              item.distributorCode,
            );
            this.Store.BusinessAddressController.onSelectAddress(firstInfo);
          }
        }

        return lodash.assign({}, item, {
          isDefault: lodash.isEmpty(firstInfo) ? false : true,
          defaultAddress: firstInfo,
          consignee: firstInfo.consignee,
          details: firstInfo.details,
          mobile: firstInfo.mobile,
          productIds: productIds,
        });
      }),
    );
    return dataSource;
  };
  /**
   * @des 订单编号
   */
  @observable
  orderNumber = '';

  /**
   * @des 订单列表
   */
  @observable
  orderList = [{ productInfo: [] }];

  @action.bound
  setOrderList(val) {
    this.orderList = val;
  }

  @action.bound
  setOrderNumber(val) {
    this.orderNumber = val;
  }

  ShopController = new BasesController({
    dataKey: 'shopId',
    infinite: true,
    pagination: EnumAPI.business_priceQuotation_getShopInfo,
  });

  async getAddressList(item, productIds) {
    const res = await this.onBusinessFindAddressList({
      distributorCode: item.distributorCode,
      productIds: lodash.uniq(productIds),
    });
    return res;
  }
  /**
   * @des 收货地址列表查询
   */
  async onBusinessFindAddressList(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_findAddressList,
      body,
    });
  }

  /**
   * @des 报价单页面转单提交
   */
  async onBusinessPriceQuotationTransferOrder(body) {
    return await AjaxBasics.request({
      ...EnumAPI.businessPriceQuotation_transferOrder,
      body,
    });
  }

  changeDefaultAddress(item) {
    const cur = lodash.filter(this.dataSource, [
      'distributorCode',
      item.distributorCode,
    ]);
    lodash.assign(cur, {
      isDefault: true,
      defaultAddress: item,
    });
  }
}
